import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';
import BodyXSText from 'shared/components/vxl/typography/primary/body/BodyXSText';
import theme from 'shared/styles/theme';

interface TransferLimitMessage {
  transferAmount: string;
  maxLimit: string;
}

const TransferLimitMessage = ({
  transferAmount,
  maxLimit,
}: TransferLimitMessage) => {
  const { t: translatedText } = useTranslation('moveMoney', {
    keyPrefix: 'sender',
  });
  const amount = parseFloat(transferAmount ?? '');
  const parsedMaxLimit = maxLimit
    ? parseFloat(maxLimit.replaceAll('$', ''))
    : 0;

  let message = `${translatedText('transferLimit')} ${maxLimit}`;
  let transferLimitTextStyle = styles.transferLimitTextStyle;

  if (isNaN(amount)) {
    message = 'Invalid amount';
    transferLimitTextStyle = styles.transferLimitErrorContainer;
  } else if (amount === 0) {
    message = `${translatedText('transferLimit')} ${maxLimit}`;
    transferLimitTextStyle = styles.transferLimitTextStyle;
  } else if (amount < 1) {
    message = translatedText('minimumTransferLimit');
    transferLimitTextStyle = styles.transferLimitErrorContainer;
  } else if (amount > parsedMaxLimit) {
    message = `${translatedText('transferLimit')} ${maxLimit}`;
    transferLimitTextStyle = styles.transferLimitErrorContainer;
  }

  return (
    <BodyXSText numberOfLines={1} style={transferLimitTextStyle}>
      {message}
    </BodyXSText>
  );
};

const styles = StyleSheet.create({
  transferLimitErrorContainer: {
    color: theme.color.status.negative,
    flexShrink: 1,
  },
  transferLimitTextStyle: { flexShrink: 1 },
});

export default TransferLimitMessage;
